import SupportedLobModules from 'integration/policycommon/SupportedLobModules';

export default angular.module('edge.policycommon.app', SupportedLobModules);